import { createStore, combineReducers, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import mainStore from './mainReducer';

const allReducer = combineReducers({
    mainStore: mainStore,
});
const store = createStore(allReducer, applyMiddleware(thunk));
export default store;
